<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Editar peso</h5>
    <div mat-dialog-content>
        <!--begin::Form-->
        <form class="form" [formGroup]="editWeightForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
            <br-alert *ngIf="showAlert"></br-alert>
            <p><strong>ID: </strong>{{weightData.id}}</p>
            <p><strong>Fecha de creación: </strong>{{weightData.createdAt | date: 'MMMM d, y'}}</p>
            <mat-form-field class="w-100">
            <mat-label>Peso</mat-label>
            <input matInput type="text"
                formControlName="weight" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('weight', 'required')">
                <strong>Campo requerido</strong>
            </mat-error>
            </mat-form-field>
        </div>
        </form>
        <!--end::Form-->
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick(false)">Cerrar</button>
        <button mat-button cdkFocusInitial (click)="submit(editWeightForm)">Guardar</button>
    </div>
</div>